var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-flex flex-column mcf-light"},[_c('div',{staticClass:"flex-grow-1 overflow-auto "},[_vm._t("content")],2),_c('div',{staticClass:"position-sticky",staticStyle:{"bottom":"0"}},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }